var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "meta"
  }, [_c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v("Name")]), _c('p', {
    staticClass: "meta_value"
  }, [_c('span', [_vm._v(_vm._s(_vm.blockchain.name))])])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v("ID")]), _c('p', {
    staticClass: "meta_value"
  }, [_c('span', [_vm._v(_vm._s(_vm.blockchain.id))])])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v("Subnet")]), _c('p', {
    staticClass: "meta_value"
  }, [_c('span', [_vm._v(_vm._s(_vm.blockchain.subnetID))])])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v("Validators")]), _c('p', {
    staticClass: "meta_value"
  }, [_c('span', [_vm._v(_vm._s(_vm.validatorsCount))])])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v("VM ID")]), _c('p', {
    staticClass: "meta_value"
  }, [_c('span', [_vm._v(_vm._s(_vm.blockchain.vmID))])])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v("Indexed")]), _c('p', {
    staticClass: "meta_value"
  }, [_c('Indexed', {
    attrs: {
      "indexed": _vm.blockchain.indexed,
      "not-indexed-label": true
    }
  })], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }